// ===== Indian Alchemy × Platinum Hospitality — content model =====

export const BRAND = {
  name: "Indian Alchemy",
  parent: "A Unit of Food Atelier",
  trademark: "™",
  tagline: "Where Indian cuisine is curated, not just cooked.",
  founded: "2001",
  email: "indianalchemy.in@gmail.com",
  phEmail: "platinumhospitality4@gmail.com",
  phone: "+91 98736 97055",
  phoneAtul: "+91 98112 97055",
  phoneJhanvi: "+91 98736 97055",
  whatsapp: "+919873697055",
  instagramHandle: "@Indianalchemy.in",
  instagram: "https://www.instagram.com/indianalchemy.in/",
  facebook: "https://www.facebook.com/indianalchemy.in/",
  address:
    "Indian Alchemy — A Unit of Food Atelier, Plot 428-429, Ground Floor, Backside, Udyog Vihar Phase III, Gurugram – 122016",
  hours: "Mon–Sat · 10:00 – 19:00 IST",
  serviceArea: ["Delhi", "Gurugram", "Noida", "Jaipur"],
};

export const WA_PREFILL = encodeURIComponent(
  "Hi, I'd like to inquire about Indian Alchemy / Platinum Hospitality catering."
);
export const WA_LINK = `https://wa.me/${BRAND.whatsapp.replace(/[^0-9]/g, "")}?text=${WA_PREFILL}`;

// ---------- Hero ----------
export const HERO = {
  eyebrow: "Indian Alchemy™ · Third-Generation Hospitality",
  title: "Where Indian cuisine is",
  titleAccent: "curated,",
  titleTail: "not just cooked.",
  sub: "Luxury event catering & corporate dining, from a family that has quietly set the table for Delhi NCR for 25 years.",
  bg: "/assets/photos/ia-festive-spread.webp",
};

// ---------- Dual brand cards on home ----------
export const DUAL_BRANDS = [
  {
    slug: "ia",
    kicker: "Indian Alchemy™",
    title: "Premium Event Catering",
    body: "Luxury weddings, HNI cocktail evenings, high teas, destination events and food festivals — considered menus, theatrical service, real ceramics.",
    cta: "Explore Indian Alchemy",
    href: "/indian-alchemy",
    tone: "ia",
  },
  {
    slug: "ph",
    kicker: "Platinum Hospitality",
    title: "Corporate Catering Solutions",
    body: "Est. 2001. 4,500 meals a day for 20+ MNCs from a 6,000 sq ft central kitchen in Udyog Vihar — reliable, scalable, precise.",
    cta: "Partner With Us",
    href: "/platinum-hospitality",
    tone: "ph",
  },
];

// ---------- Services snapshot (home grid) ----------
export const SERVICES_SNAPSHOT = [
  { title: "Weddings", img: "/assets/photos/ia-lantern-buffet.webp" },
  { title: "Cocktail Evenings", img: "/assets/photos/ia-pav-sliders.webp" },
  { title: "High Tea Soirées", img: "/assets/photos/ia-dessert-canapes.webp" },
  { title: "Corporate Events", img: "/assets/photos/ia-corporate-buffet.webp" },
  { title: "Destination Events", img: "/assets/photos/ia-outdoor-night-dining.webp" },
  { title: "Live Cooking Stations", img: "/assets/photos/ia-live-grill-chef.webp" },
  { title: "Bento Box Catering", img: "/assets/photos/ia-bento-packaging.webp" },
  { title: "Food Festivals", img: "/assets/photos/ia-grand-spread-flatlay.webp" },
];

// ---------- Numbers strip ----------
export const STATS = [
  { k: 25, suffix: "+", label: "Years of Excellence" },
  { k: 4500, suffix: "+", label: "Meals Daily" },
  { k: 20, suffix: "+", label: "MNC Partners" },
  { k: 4, suffix: "", label: "Cities" },
];

// ---------- Testimonials ----------
export const TESTIMONIALS = [
  {
    quote:
      "A huge thank you to you and your team for the most wonderful catering and hospitality during our week of meetings at the S&P Global Downtown office. The menus were inventive and truly international, whilst showing an absolute pride in Indian heritage. We had wonderful feedback from everyone who attended. We also appreciated the flexibility when timings changed — very challenging, but you were ready every time we asked, which was so impressive.",
    author: "Liz Cranfield",
    role: "Global Director of Facilities Management, CBRE · S&P Global, London",
    tag: "Corporate · London",
  },
  {
    quote:
      "Indian Alchemy transformed our daughter's wedding into an unforgettable culinary journey. Every dish was a work of art.",
    author: "Wedding Client",
    role: "Delhi",
    tag: "Wedding",
  },
  {
    quote:
      "Platinum Hospitality has been our cafeteria partner for 8 years. Consistency, quality, zero complaints.",
    author: "HR Head",
    role: "MNC · Gurugram",
    tag: "Corporate",
  },
  {
    quote:
      "The cocktail evening they curated for our product launch was spectacular. Our guests are still talking about it.",
    author: "Marketing Director",
    role: "Delhi NCR",
    tag: "Cocktail Evening",
  },
  {
    quote:
      "From the Biryani Fest to the Sattvik Soirée — every themed event they've done for us has been outstanding.",
    author: "Corporate Events Manager",
    role: "Gurugram",
    tag: "Food Festival",
  },
];

// ---------- Instagram feed placeholder tiles ----------
export const INSTA_TILES = [
  "/assets/photos/ia-saffron-dessert.webp",
  "/assets/photos/ia-stuffed-kulcha.webp",
  "/assets/photos/ia-tandoori-chicken.webp",
  "/assets/photos/ia-appetiser-platter.webp",
  "/assets/photos/ia-matka-desserts.webp",
  "/assets/photos/ia-charcuterie-board.webp",
  "/assets/photos/ia-signature-curry.webp",
  "/assets/photos/ia-copper-handi-buffet.webp",
  "/assets/photos/ia-seekh-kebab.webp",
];

// ---------- Timeline ----------
export const TIMELINE = [
  { year: "2001", body: "Platinum Hospitality founded by Yogesh N Saxena." },
  { year: "2010s", body: "Growth to 20+ MNC clients across Delhi NCR." },
  { year: "2018", body: "Indian Alchemy™ launched — the luxury event arm of the family kitchen." },
  { year: "2021", body: "Times Food Delivery Icons — Delhi NCR public recognition." },
  { year: "2022", body: "ETHospitalityWorld feature — 'A chip off the family business' by Bikramjit Ray." },
  { year: "Today", body: "4,500 meals a day for 20+ MNC clients across four cities. And counting." },
];

// ---------- Founders (About cards — Atul, Jhanvi active + Yogesh as legacy mention) ----------
export const FOUNDERS = [
  {
    name: "Atul Celly",
    role: "Proprietor",
    bio: "Second-generation hospitality. Atul leads kitchen operations, supplier relationships and the compliance backbone that keeps 4,500 meals a day moving cleanly across Delhi NCR.",
  },
  {
    name: "Jhanvi Celly Saxena",
    role: "CMO · Indian Alchemy",
    bio: "In the family business since age sixteen. Jhanvi leads brand, menu design and the theatrical service style that has become the family's signature at every Indian Alchemy event.",
  },
  {
    name: "Yogesh N Saxena",
    role: "Founder · Platinum Hospitality · Legacy",
    bio: "Founded Platinum Hospitality in 2001 and set the standard of reliability, precision and quiet consistency that both brands stand on today. His work continues in every menu that leaves the kitchen.",
  },
];

// ---------- In-memory tribute to the late Mrs. Ekta Celly ----------
export const EKTA = {
  name: "Mrs. Ekta Celly",
  epitaph: "Our Guiding Force & Light",
  years: null, // add "1970 — 2023" or similar if desired
  body:
    "Ekta believed every meal served was an act of love — a way of saying you are seen, you are cared for, you are home. Her warmth set the tone for how our brigade greets a guest, how our chefs plate a dish, how our team stays after a long night to make sure the last table was looked after. She is not on our team roster today. She is in every one of these decisions, every day. This kitchen is her kitchen, still.",
  photo: "/assets/photos/ekta-celly.webp",
};

// ---------- Cuisine expertise (IA services page) ----------
export const CUISINES = [
  { label: "North Indian", img: "/assets/photos/ia-copper-kadhai-curry.webp" },
  { label: "South Indian", img: "/assets/photos/ia-banana-leaf-fish.webp" },
  { label: "Continental", img: "/assets/photos/ia-continental-plated.webp" },
  { label: "Oriental", img: "/assets/photos/ia-oriental-rolls.webp" },
  { label: "Pan-Asian", img: "/assets/photos/ia-roasted-aubergine.webp" },
  { label: "Fusion", img: "/assets/photos/ia-stuffed-kulcha.webp" },
];

// ---------- Press ----------
export const PRESS = [
  {
    outlet: "Times Food Delivery Icons",
    date: "Gurgaon · 2021",
    note: "OptimalMedia feature recognising the family business.",
  },
  {
    outlet: "ETHospitalityWorld",
    date: "February 15, 2022",
    note: "'A chip off the family business' — Bikramjit Ray.",
    href: "https://hospitality.economictimes.indiatimes.com/",
  },
];

// ---------- Indian Alchemy service pages ----------
export const IA_SERVICES = [
  {
    n: "01",
    title: "Weddings",
    body: "Diverse buffet spreads, exquisite plated service, bespoke menu design. From traditional Indian delicacies to international cuisines. Customisation for every wedding style and scale.",
    img: "/assets/photos/ia-grazing-table-event.webp",
  },
  {
    n: "02",
    title: "Cocktail Evenings",
    body: "Signature Indian-inspired cocktails crafted by expert mixologists. Curated spirits and non-alcoholic beverage menus. Perfect for product launches, celebrations, and private gatherings.",
    img: "/assets/photos/ia-pav-sliders.webp",
  },
  {
    n: "03",
    title: "High Tea Soirées",
    body: "Elegant tea presentations, artisanal finger food, and dessert stations. A sophisticated experience for intimate gatherings.",
    img: "/assets/photos/ia-dessert-canapes.webp",
  },
  {
    n: "04",
    title: "Corporate Events",
    body: "Leadership meets, offsites, product launches, annual days, townhalls. Seamless execution at scale.",
    img: "/assets/photos/ia-corporate-buffet.webp",
  },
  {
    n: "05",
    title: "Destination Events",
    body: "Full-service catering at destination wedding venues. Jaipur and beyond. Complete kitchen setup and service at any venue.",
    img: "/assets/photos/ia-outdoor-night-dining.webp",
  },
  {
    n: "06",
    title: "Live Cooking Stations",
    body: "Live grills, pasta stations, chaat counters, interactive dessert bars. Skilled chefs preparing dishes on the spot, adding theatre to the dining experience.",
    img: "/assets/photos/ia-live-grill-chef.webp",
  },
  {
    n: "07",
    title: "Bento Box Catering",
    body: "Three tiers — Classic (₹850/box), Premium, and Signature (₹1,400/box). Vegetarian and non-vegetarian options. Ideal for corporate meetings, working lunches and private events.",
    img: "/assets/photos/ia-bento-packaging.webp",
    tiers: [
      { name: "Classic", price: "₹ 850", desc: "3-course, seasonal, packed hot." },
      { name: "Premium", price: "₹ 1,100", desc: "4-course with signature sides." },
      { name: "Signature", price: "₹ 1,400", desc: "5-course tasting bento." },
    ],
  },
  {
    n: "08",
    title: "Food Festivals",
    body: "Regional themed days — Rajasthani, Hyderabadi, Bengali, Chinese, Healthy. Bringing culinary diversity to corporate cafeterias and events.",
    img: "/assets/photos/ia-grand-spread-flatlay.webp",
  },
  {
    n: "09",
    title: "Sattvik Soirées",
    body: "Pure no-onion, no-garlic menus for spiritual events and celebrations. Elevated vegetarian cuisine rooted in tradition.",
    img: "/assets/photos/ia-saffron-dessert.webp",
  },
];

export const DIETARY = ["Vegetarian", "Vegan", "Jain (no onion/garlic)", "Gluten-Free", "Allergen-Free"];

// ---------- Platinum Hospitality ----------
export const PH_KEY_FACTS = [
  { k: "25+", v: "Years of unbroken operation" },
  { k: "2,500+", v: "Individuals served daily" },
  { k: "4,500", v: "Meals per day capacity" },
  { k: "6,000", v: "sq ft central kitchen" },
  { k: "80", v: "Employees across kitchen & site" },
  { k: "4", v: "Cities across Delhi NCR & beyond" },
];

export const PH_SAMPLE_MENU_TABLE = [
  { day: "Monday",    dal: "Dal Makhani",     veg: "Methi Alu",      rice: "Onion Rice",  curd: "Boondi Raita", sweet: "Balushai" },
  { day: "Tuesday",   dal: "Rajasthani Dal",  veg: "Matar Paneer",   rice: "Zeera Rice",  curd: "Kheera Raita", sweet: "Meetha Samosa" },
  { day: "Wednesday", dal: "Rajmah",          veg: "Gobhi Alu",      rice: "Plain Rice",  curd: "Onion Raita",  sweet: "Kheer" },
  { day: "Thursday",  dal: "Kadi Pakora",     veg: "Mix Veg",        rice: "Plain Rice",  curd: "Plain Curd",   sweet: "Fruit Custard" },
  { day: "Friday",    dal: "Pindi Chana",     veg: "Kathal Masala",  rice: "Veg Pulao",   curd: "Alu Raita",    sweet: "Coconut Ladoo" },
  { day: "Saturday",  dal: "Lucknowi Masur",  veg: "Malai Kofta",    rice: "Peas Pulao",  curd: "Mix Raita",    sweet: "Imerti" },
];

export const PH_SERVICES = [
  {
    title: "Full Thali, Mini Meals, Packed & Combo Meals",
    body: "A wide range of meal options to cater to diverse tastes, from full thalis to packed lunch combos and live counters.",
  },
  {
    title: "Healthy Food",
    body: "Wholesome and balanced meals prepared according to recommendations of our in-house dietician.",
  },
  {
    title: "North Indian, South Indian, Continental & Oriental",
    body: "A culinary journey to satisfy every palate, run by chefs trained in each idiom.",
  },
  {
    title: "Salads & Fruits",
    body: "Fresh and nutritious options to promote a healthy lifestyle, refreshed twice a day.",
  },
  {
    title: "Food Festivals",
    body: "State-wise themed festivals — Rajasthani, Bengali, Awadhi, Continental, South Indian — as weekly / monthly pop-ups in corporate cafeterias.",
  },
];

export const PH_SAMPLE_MENU = [
  { day: "Mon", items: ["Dal Makhani", "Methi Alu", "Onion Rice", "Boondi Raita", "Balushai"] },
  { day: "Tue", items: ["Rajasthani Dal", "Matar Paneer", "Zeera Rice", "Kheera Raita", "Meetha Samosa"] },
  { day: "Wed", items: ["Rajmah", "Gobhi Alu", "Plain Rice", "Onion Raita", "Kheer"] },
  { day: "Thu", items: ["Kadi Pakora", "Mix Veg", "Plain Rice", "Plain Curd", "Fruit Custard"] },
  { day: "Fri", items: ["Pindi Chana", "Kathal Masala", "Veg Pulao", "Alu Raita", "Coconut Ladoo"] },
  { day: "Sat", items: ["Lucknowi Masur", "Malai Kofta", "Peas Pulao", "Mix Raita", "Imerti"] },
];

export const PH_FESTIVALS = [
  { day: "Mon", region: "Rajasthani", items: ["Murg Rogan Josh", "Jaipuri Vegetables", "Suji Halwa"] },
  { day: "Tue", region: "Bengali", items: ["Doi Maach", "Alur Dom", "Rasgulla"] },
  { day: "Wed", region: "Awadhi", items: ["Zaffrani Murg", "Zaffrani Paneer", "Shahi Tukda"] },
  { day: "Thu", region: "Continental", items: ["Chicken Red Thai Curry", "Green Thai Curry", "Pasta Arrabiata", "Mini Pastry"] },
  { day: "Fri", region: "South Indian", items: ["Madras Chicken Curry", "Cabbage Poriyal", "Vegetable Stew", "Coconut Ladoo"] },
];

export const PH_KITCHEN = [
  { title: "Receiving Area", body: "Inspection and cold-chain intake for every ingredient." },
  { title: "Cutting Area", body: "Separate zones for vegetarian and non-vegetarian to prevent cross-contamination." },
  { title: "Cooking Area", body: "Separate zones for vegetarian and non-vegetarian, adhering to dietary preferences." },
  { title: "Dispatch Area", body: "Streamlined order preparation and on-time delivery." },
  { title: "Cold Room / Refrigerator", body: "Storage and preservation of perishable items at HACCP-mandated temperatures." },
  { title: "Storage", body: "Organised, labelled and rotated storage of dry goods and packaging." },
];

export const PH_PILLARS = [
  { n: "01", title: "Extensive Experience", body: "25+ years, honed to perfection across every meal category." },
  { n: "02", title: "Diverse Menu Options", body: "Wide range of cuisines and meal choices for every taste and dietary requirement." },
  { n: "03", title: "Professional Staff", body: "Highly skilled culinary experts and a dedicated service team." },
  { n: "04", title: "Timely Delivery", body: "Efficient logistics, dedicated delivery team, reliable fleet, real-time tracking." },
  { n: "05", title: "Customisation", body: "Tailored solutions — dietary restrictions, special menu requests, themed events, personalised meal plans." },
  { n: "06", title: "Quality Assurance", body: "Stringent quality control, HACCP guidelines, documentation and traceability of every ingredient." },
  { n: "07", title: "Trusted Partnership", body: "Collaborative, long-lasting relationships and responsive customer support end-to-end." },
];

export const PH_CERTS = [
  "FSSAI Licensed",
  "FSSAI Food Handlers (Individual)",
  "HACCP Certified",
  "NABL Food & Water Testing",
  "GST Registered",
  "MSME Registered",
  "PF / ESI Compliant",
  "Fire NOC",
  "Trade License",
  "Comprehensive Insurance",
  "EH&S Program (EH&S-PH-001)",
];

export const PH_CLIENTS_CATERING = [
  "ThoughtWorks Technologies · Gurgaon",
  "KELLTON Tech Solutions · Gurgaon",
  "Orient Electric Company · Gurgaon",
  "Moody's Shared Services · Gurgaon",
  "British Telecom · Gurgaon",
  "Tata-Play · New Delhi",
  "Accenture · Gurgaon",
  "FinThrive India Pvt. Ltd. · Gurgaon",
  "Unlimit Pvt. Ltd. · Gurgaon",
  "PERFETTI · Gurgaon",
  "Goodricke Group · Gurgaon",
];

export const PH_CLIENTS_EVENTS = [
  "S&P Global / CBRE · Gurgaon & London",
  "Group M Media · Gurgaon",
  "NYKAA · Delhi & Gurgaon",
  "Savills Property Services · Gurgaon",
  "Ogilvy & Mather Pvt. Ltd. · Gurgaon",
  "S&P Capital IQ · Gurgaon",
  "ACB India · India",
  "Market India Services · Gurgaon & Noida",
  "British Telecom (Events) · Gurgaon",
  "United Airlines · Gurgaon",
  "Expedia Group · Gurgaon",
  "Adani Group · Delhi NCR",
  "JioHotstar · Delhi NCR",
];

export const PH_CLIENT_LOGOS = {
  "ThoughtWorks Technologies": "/assets/logos/thoughtworks.png",
  "KELLTON Tech Solutions": "/assets/logos/kellton-tech.png",
  "Orient Electric Company": "/assets/logos/orient-electric.png",
  "Moody's Shared Services": "/assets/logos/moodys.png",
  "British Telecom": "/assets/logos/british-telecom.png",
  "British Telecom (Events)": "/assets/logos/british-telecom.png",
  "Tata-Play": "/assets/logos/tata-play.png",
  "Accenture": "/assets/logos/accenture.png",
  "FinThrive India Pvt. Ltd.": "/assets/logos/finthrive.png",
  "Unlimit Pvt. Ltd.": "/assets/logos/unlimit.png",
  "PERFETTI": "/assets/logos/perfetti-van-melle.png",
  "S&P Global / CBRE": "/assets/logos/sp-global.png",
  "S&P Capital IQ": "/assets/logos/sp-global.png",
  "Group M Media": "/assets/logos/groupm.png",
  "NYKAA": "/assets/logos/nykaa.png",
  "Savills Property Services": "/assets/logos/savills.png",
  "United Airlines": "/assets/logos/united-airlines.png",
  "Expedia Group": "/assets/logos/expedia.png",
  "Adani Group": "/assets/logos/adani.png",
  "JioHotstar": "/assets/logos/jiohotstar.png",
};

export const PH_EVENT_FORMATS = [
  "Leadership Meets & Boardroom Events",
  "Conferences, Seminars & Corporate Offsites",
  "Product Launches & Brand Activations",
  "Annual Days, Townhalls & Employee Engagement",
  "Festive Celebrations & Themed Corporate Events",
  "High-Tea, Cocktail & Networking Events",
];

// ---------- Portfolio ----------
export const PORTFOLIO_CATEGORIES = [
  { id: "weddings", label: "Weddings" },
  { id: "corporate", label: "Corporate" },
  { id: "cocktail", label: "Cocktail Evenings" },
  { id: "hightea", label: "High Teas" },
  { id: "destination", label: "Destination" },
  { id: "festivals", label: "Food Festivals" },
  { id: "bento", label: "Bento & Packaging" },
];

export const PORTFOLIO = [
  { id: "w1", category: "weddings", title: "Lantern-Lit Banquet", location: "Delhi NCR", year: "2024", src: "/assets/photos/ia-lantern-buffet.webp" },
  { id: "w2", category: "weddings", title: "Brass & Copper Table", location: "Delhi", year: "2024", src: "/assets/photos/ia-copper-handi-buffet.webp" },
  { id: "w3", category: "weddings", title: "Fairy-Lit Live Station", location: "Gurugram", year: "2023", src: "/assets/photos/ia-live-station-fairy-lights.webp" },
  { id: "c1", category: "corporate", title: "Corporate Buffet Service", location: "Gurugram", year: "2025", src: "/assets/photos/ia-corporate-buffet.webp" },
  { id: "c2", category: "corporate", title: "Working Lunch Spread", location: "Delhi NCR", year: "2024", src: "/assets/photos/ia-festive-spread.webp" },
  { id: "co1", category: "cocktail", title: "Cocktail Canapés", location: "Delhi", year: "2025", src: "/assets/photos/ia-pav-sliders.webp" },
  { id: "co2", category: "cocktail", title: "Matka Dessert Bar", location: "Delhi", year: "2024", src: "/assets/photos/ia-matka-desserts.webp" },
  { id: "h1", category: "hightea", title: "Afternoon High Tea", location: "Gurugram", year: "2024", src: "/assets/photos/ia-dessert-canapes.webp" },
  { id: "d1", category: "destination", title: "Dinner Under the Stars", location: "Delhi NCR", year: "2024", src: "/assets/photos/ia-outdoor-night-dining.webp" },
  { id: "d2", category: "destination", title: "Grazing Table Evening", location: "Gurugram", year: "2024", src: "/assets/photos/ia-grazing-table.webp" },
  { id: "f1", category: "festivals", title: "Awadhi Week", location: "Corporate Cafeteria", year: "2025", src: "/assets/photos/ia-seekh-kebab.webp" },
  { id: "f2", category: "festivals", title: "Regional Curry Pop-up", location: "Gurugram", year: "2024", src: "/assets/photos/ia-copper-kadhai-curry.webp" },
  { id: "b1", category: "bento", title: "Signature Bento", location: "Delhi NCR", year: "2025", src: "/assets/photos/ia-bento-packaging.webp" },
  { id: "b2", category: "bento", title: "Premium Packaging", location: "Delhi NCR", year: "2024", src: "/assets/photos/ia-grand-spread-flatlay.webp" },
];

// ---------- Consultation form options ----------
export const CONSULT = {
  eventTypes: [
    "Wedding",
    "Cocktail Evening",
    "High Tea",
    "Corporate Event",
    "Destination Event",
    "Food Festival",
    "Daily Cafeteria",
    "Other",
  ],
  guestRanges: ["50 – 100", "100 – 250", "250 – 500", "500+"],
  cuisines: [
    "North Indian",
    "South Indian",
    "Continental",
    "Oriental",
    "Pan-Asian",
    "International",
    "Mix",
  ],
  dietary: [
    "Strictly Vegetarian",
    "Jain",
    "Non-Veg OK",
    "Gluten-Free Required",
  ],
  serviceStyles: ["Buffet", "Plated", "Live Stations", "Bar Service", "Bento", "Other"],
  budgets: [
    "Below ₹1 Lakh",
    "₹1L – ₹5L",
    "₹5L – ₹15L",
    "₹15L+",
    "Prefer not to say",
  ],
  discovery: ["Instagram", "Referral", "Google", "Event", "Other"],
};

// Legacy re-exports so existing screens keep working while we transition:
export const HERO_LINES = [HERO.title, HERO.titleAccent, HERO.titleTail];
export const MARQUEE_ITEMS = ["Weddings", "Corporate", "Cocktail", "High Tea", "Destination", "Bento", "Food Festivals"];
export const EVENT_TYPES = CONSULT.eventTypes;
export const BUDGET_RANGES = CONSULT.budgets;
